// src/components/strumenti/UnitaRack.js — W442. Unità rack occupate e armadio consigliato
import React from "react";
import { useCampi, Campo, Testo, Risultato, Formula, Azzera, Avviso } from "./UiStrumento";
import { unitaRack } from "../../utils/calcoliStrumenti";
import { leggiNumero } from "../../utils/numeriStrumenti";

/** «Apparato ; U ; quantità» per riga (quantità facoltativa). Anche solo il numero di U. */
export function righeRack(testo) {
  const unita = [], errate = [];
  String(testo || "").split("\n").map(r => r.trim()).filter(Boolean).forEach((r, i) => {
    const p = r.split(/[;\t]/).map(x => x.trim());
    const numeri = p.map(leggiNumero);
    const iU = Number.isFinite(numeri[0]) ? 0 : 1;
    const u = numeri[iU], q = p.length > iU + 1 ? numeri[iU + 1] : 1;
    if (!(u > 0) || !(q >= 1) || !Number.isInteger(q)) { errate.push(i + 1); return; }
    for (let k = 0; k < q; k++) unita.push(u);
  });
  return { unita, errate };
}

export default function UnitaRack() {
  const { v, set, n, azzera } = useCampi({ testo:"", scorta:"30" });
  const { unita, errate } = righeRack(v.testo);
  const r = unita.length ? unitaRack(unita, n("scorta")) : null;
  return (
    <div>
      <div style={{ marginBottom:12 }}>
        <Testo etichetta="Apparati, uno per riga: nome ; U ; quantità" valore={v.testo} onChange={set("testo")} placeholder={"Patch panel 24 porte ; 1 ; 2\nPassacavi ; 1 ; 2\nSwitch 48 porte ; 1 ; 1\nNVR ; 2 ; 1\nUPS ; 2 ; 1"} righe={6} aiuto="La quantità è facoltativa (1 se manca)."/>
      </div>
      <div style={{ marginBottom:12 }}><Campo etichetta="Scorta per espansioni (%)" valore={v.scorta} onChange={set("scorta")}/></div>
      {errate.length > 0 && <Avviso>Righe non lette: {errate.join(", ")} (U maggiore di zero, quantità intera).</Avviso>}
      <Risultato settore="reti" titolo="Armadio consigliato" valore={r ? (r.armadio ? r.armadio + " U" : "oltre 47 U") : "—"}
        righe={r ? [["Unità occupate", r.occupate + " U"], ["Con la scorta", r.necessarie + " U"]] : []}/>
      <Formula>U necessarie = somma delle U × (1 + scorta), arrotondata per eccesso; armadio = prima taglia commerciale uguale o maggiore (6, 9, 12, 15, 18, 22, 24, 27, 32, 36, 42, 47 U). Verifica anche profondità, peso e ventilazione.</Formula>
      <Azzera onClick={azzera}/>
    </div>
  );
}
